
<template>
    <div>
<div class="success">
         <img src="../../../static/success-icon.png" alt="">
         <p>支付成功</p>
         <p>代付订单已支付完成，快去通知亲友吧</p>
         <span @click="checkCity">点击查看海量好书></span>
     </div>
    </div>
</template>
<script>

export default {
   data(){
       return{

       }
   },
   methods:{
          checkCity(){
          this.$router.replace({
              path: "/",
              query: {
                tabIndex:1,
              },
            });
    },
   }
}
</script>
<style scoped>
.success{
    background-color: #ffffff;
    height: 100%;
   padding-top: 60px;
   box-sizing: border-box;
   text-align: center;

}
.success>img{
 width: 96px;
    height: 96px;
    margin-bottom: 14px;
    
}
.success>p{
    font-size: 16px;
color: #aeaeae;
margin-bottom: 50px;
}
.success>span{
    font-size: 14px;
color: #2D9EF2;
letter-spacing: 0;
display: block;
}
.success>p:nth-of-type(1){
font-size: 20px;
color: #333333;
margin-bottom: 25px;
}
</style>



// WEBPACK FOOTER //
// src/view/paySuccess/index.vue